import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { ApiResponse } from '@/types/addContainerBlExportType';
import Endpoints from '@/enums/Endpoints';

type CambiarFechaServicioTerminalRequest = {
  oidVisita: number;
  nuevaFecha: string;
};

export const cambiarFechaServicioTerminal = async (
  query: CambiarFechaServicioTerminalRequest
): Promise<ApiResponse['value']> => {
  try {
    const res = await apiClient.post<ApiResponse>(
      Endpoints.CambiarFechaServicioTerminal,
      query
    );

    if (res?.data?.value?.ok === false) {
      throw new Error(res?.data?.value?.mensaje);
    }

    if (res?.data?.value?.error) {
      throw new Error(res?.data?.value?.error);
    }

    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
